import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Avatar,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
//Date
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
//Srcs
import "../Style/pagestyle.scss";
import EmptyData from "../Components/Include/EmptyData";
import LoadingPage from "../Components/Include/LoadingPage";
import { AuthContext } from "../Context/AuthContext";
import { translateLauguage } from "../Function/Translate";
import FooterPagination from "../Components/Include/FooterPagination";
import { GET_STUDENT_PAYMENT_BY_MONTH } from "../Schema/StudentPayment";
import { currencyFormat } from "../Function/DynamicFn";
import { SelectService } from "../Components/Include/DynamicSelect";

export default function SchoolService() {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);
  const [serviceVal, setServiceVal] = useState({ id: "", title: "" });
  const [date, setDate] = useState();

  const { refetch } = useQuery(GET_STUDENT_PAYMENT_BY_MONTH, {
    variables: {
      page: page,
      limit: limit,
      service: serviceVal?.id ? serviceVal?.id : "",
      month: moment(date).format("MM"),
      year: moment(date).format("YYYY"),
    },
    onCompleted: ({ getStudentsPaymentByMonth }) => {
      // console.log("getStudentsPaymentByMonth", getStudentsPaymentByMonth);
      setTableData(getStudentsPaymentByMonth?.data);
      setPaginationData(getStudentsPaymentByMonth?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  useEffect(() => {
    if (tableData?.length !== 0) {
      let refetchData = tableData?.filter((d) => d?.role === null);
      if (refetchData?.length !== 0) {
        refetch();
      }
    }
  }, [tableData]);

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">School Service</Typography>
        </Stack>
        <Box sx={{ flexGrow: 1 }} />
        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              Dashboard
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">
              School Service
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
            <Typography className="search-head-title">
              Select service
            </Typography>
            <SelectService
              selectedVal={serviceVal}
              setSelectedVal={setServiceVal}
              className="search-field"
            />
          </Grid>
          <Grid item xs={4} sm={4} md={2} lg={2} xl={1.6}>
            <Typography className="search-head-title">Select month</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                onChange={(e) => setDate(e)}
                inputFormat="MMMM"
                views={["month"]}
                className="search-field"
                renderInput={(params) => (
                  <TextField size="small" {...params} type="date" fullWidth />
                )}
                value={date !== "" ? date : ""}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={4} sm={4} md={2} lg={2} xl={1.6}>
            <Typography className="search-head-title">Select year</Typography>
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              className="search-field"
            >
              <DatePicker
                className="search-field"
                onChange={(e) => setDate(e)}
                inputFormat="yyyy"
                views={["year"]}
                renderInput={(params) => (
                  <TextField
                    className="select-date"
                    size="small"
                    {...params}
                    type="date"
                    fullWidth
                  />
                )}
                value={date !== "" ? date : ""}
              />
            </LocalizationProvider>
          </Grid>

          {/* <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                {t("create")}
              </Button>

              <CreateGroupFee
                open={open}
                handleClose={handleClose}
                setRefetch={refetch}
              />
            </Stack>
          </Grid> */}
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableCell className="header-title-start">{t("no")}</TableCell>
              <TableCell className="header-title">Student ID</TableCell>
              <TableCell className="header-title">Full Name</TableCell>
              <TableCell className="header-title">Latin Name</TableCell>
              <TableCell className="header-title">Gender</TableCell>
              <TableCell className="header-title">Services</TableCell>
              {/* <TableCell className="header-title">Last Paid</TableCell>
              <TableCell className="header-title">Last Payment</TableCell> */}
              <TableCell className="header-title-end">To Pay</TableCell>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell
                    colSpan={10}
                    className="body-cell"
                    sx={{ bgcolor: "#fff" }}
                  >
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell className="body-cell-start">
                              {index + paginationData?.slNo}
                            </TableCell>
                            <TableCell className="body-cell">002323</TableCell>
                            <TableCell className="body-cell">
                              <Stack
                                direction="row"
                                spacing={1}
                                className="student-info"
                              >
                                <Stack
                                  direction="column"
                                  justifyContent="center"
                                >
                                  <Avatar
                                    alt={row?.first_name}
                                    src={
                                      row?.profileImg?.slice(0, 5) === "https"
                                        ? row?.profileImg
                                        : `${process.env.REACT_APP_VIEW_URL}${row?.profileImg}`
                                    }
                                  />
                                </Stack>
                                <Stack
                                  direction="column"
                                  justifyContent="center"
                                >
                                  <Typography className="student-name">
                                    {row?.lastName + " " + row?.firstName}
                                  </Typography>
                                </Stack>
                              </Stack>
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.englishName}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.gender}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.service}
                            </TableCell>
                            <TableCell className="body-cell-end">
                              ${currencyFormat(row?.toPay)}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ================================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
